'use client'

import type { MenuItem } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { MenuActionId } from '@common/core/enums'

export function createSwitchProjectItem(projectGroupItems: MenuItem[]): MenuItem {
  const groups: MenuItem['groups'] = []

  if (projectGroupItems.length > 0) {
    groups.push({
      id: 'group-1',
      searchable: true,
      label: 'Projects',
      separatorAfter: true,
      items: projectGroupItems,
    })
  }

  groups.push({
    id: 'group-2',
    items: [
      {
        type: 'item',
        icon: Icon.AddRegular,
        active: true,
        groups: [],
        label: 'Create project',
        id: MenuActionId.CREATE_PROJECT_DIALOG,
        size: 'xs',
      },
    ],
  })

  return {
    type: 'item',
    icon: Icon.FolderRegular,
    active: true,
    label: 'Switch project',
    id: 'item-5',
    size: 'xs',
    groups,
  }
}
